import { trackEvent } from "../app/Firebase";

const sendFirebaseEvent = (title, category, action, label) => {
  trackEvent(title, {
    category,
    action,
    label: label?.toString(),
  });
};

export default sendFirebaseEvent;